import * as React from 'react';
import BatchInputCodeTableViewCell from './BatchInputCodeTableViewCell';
import BatchInputCodeTableViewHeader from './BatchInputCodeTableViewHeader';

interface BatchInputCodeTableViewProps {
    tableType: string,
    list: any[]
}

class BatchInputCodeTableView extends React.Component <BatchInputCodeTableViewProps, {}> {
    public getInputCode() {
        const cells = [];
        for (let i = 0; i < this.props.list.length; i++) {
            const data = this.props.list[i];
            cells.push(
                <BatchInputCodeTableViewCell
                    key={i}
                    code={data.shortId || data.first}
                    fullName={data.displayName || data.second}/>);
        }
        return cells;
    }

    public render() {
        return (
            <div className="batchInputCodeTableViewContainer">
                <BatchInputCodeTableViewHeader tableType={this.props.tableType}/>
                {this.getInputCode()}
            </div>
        );
    }
}

export default BatchInputCodeTableView;


// WEBPACK FOOTER //
// ./src/Components/Batch/BatchInputCodeTableView.tsx